// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"36c6fcce","43":"62e8edae","137":"915c09f7","256":"5f9a8066","311":"198741c9","313":"3cb917f2","352":"8fca9cda","499":"1b88c3f7","518":"c1d26c9e","569":"3737e20d","699":"c0997859","884":"835cdbc2","950":"07473a01"}[chunkId] + ".chunk.js";
};